import React from 'react';
interface PaymentRecord {
  date: string;
  type: string;
  reference: string;
  amount: number;
  currency: string;
}
interface PaymentHistoryProps {
  payments: PaymentRecord[];
}
export function PaymentHistory({
  payments
}: PaymentHistoryProps) {
  const formatCurrency = (amount: number, currency: string) => {
    return `${currency} ${amount.toFixed(2)}`;
  };
  return <div className="mt-8" data-id="element-902">
      <h3 className="text-lg font-bold text-neutral-900 mb-4 uppercase tracking-wide" data-id="element-903">
        Payment History
      </h3>

      <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-904">
        {/* Table Header */}
        <div className="grid grid-cols-12 gap-4 bg-neutral-100 px-6 py-3 border-b border-neutral-200" data-id="element-905">
          <div className="col-span-3 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-906">
            Date
          </div>
          <div className="col-span-3 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-907">
            Type
          </div>
          <div className="col-span-3 text-sm font-semibold text-neutral-700 uppercase tracking-wide" data-id="element-908">
            Reference
          </div>
          <div className="col-span-3 text-sm font-semibold text-neutral-700 text-right uppercase tracking-wide" data-id="element-909">
            Amount
          </div>
        </div>

        {/* Payment Rows */}
        {payments.length > 0 ? payments.map((payment, index) => <div key={index} className="grid grid-cols-12 gap-4 px-6 py-3.5 border-b border-neutral-100 last:border-b-0 hover:bg-neutral-50 transition-colors" data-id="element-910">
              <div className="col-span-3 text-sm text-neutral-900" data-id="element-911">
                {payment.date}
              </div>
              <div className="col-span-3 text-sm text-neutral-700" data-id="element-912">
                {payment.type}
              </div>
              <div className="col-span-3 text-sm text-neutral-700" data-id="element-913">
                {payment.reference}
              </div>
              <div className="col-span-3 text-sm text-neutral-900 tabular-nums text-right font-semibold" data-id="element-914">
                {formatCurrency(payment.amount, payment.currency)}
              </div>
            </div>) : <div className="px-6 py-8 text-center text-sm text-neutral-500 italic" data-id="element-915">
            No payment history available
          </div>}
      </div>
    </div>;
}